<template>
  <div v-if="isSuccessRegister">
    <h3 class="ts-auth-title fw-bold mb-3">{{ translations[13898] }}</h3>
    <p v-if="getPasswordRegister">
      {{ translations[10809] }}
    </p>
    <p v-else>
      {{ translations[13899] }}
    </p>
    <p>
      {{ translations[13932] }}
      <a class="fw-bolder" href="#" @click.prevent="reloadTab">
        {{ translations[13933] }}
      </a>
    </p>
  </div>
  <b-form ref="registerForm" v-else autocomplete="new-password" @keydown="handleKeydown">
    <b-alert :show="isErrorsRegister" variant="danger">
      <span v-if="isUsernameExist">{{ translations[232] }}</span>
      <span v-if="isEmailExist">{{ translations[10870] }}</span>
    </b-alert>
    <b-alert :show="isRecaptchaError" variant="danger"> Please confirm the captcha. </b-alert>
    <b-alert :show="isRegisterPasswordError" variant="danger">
      {{ translations[240] }}
    </b-alert>
    <!--    new field 30.07.2024-->
    <div class="mb-2">
      <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[1315] }}</h3>
      <div class="ts-register-fields d-flex flex-column gap-2">
        <b-form-group v-if="isApplicantFieldExist(regField.username)" class="mb-0">
          <b-form-input
            v-model="register.username"
            type="text"
            autocomplete="new-password"
            :placeholder="translations[11001]"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="isApplicantFieldExist(regField.email)" class="mb-0">
          <b-form-input
            v-model="register.email"
            type="email"
            autocomplete="new-password"
            :placeholder="translations[5549]"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="isApplicantField(typeField.visible, regField.firstname)" class="mb-0">
          <b-form-input
            v-model="register.firstname"
            type="text"
            :placeholder="translations[234]"
            :required="isApplicantField(typeField.mandatory, regField.firstname)"
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="isApplicantField(typeField.visible, regField.lastname)" class="mb-0">
          <b-form-input
            v-model="register.lastname"
            type="text"
            :placeholder="translations[235]"
            :required="isApplicantField(typeField.mandatory, regField.lastname)"
          ></b-form-input>
        </b-form-group>
        <PasswordPattern
          v-if="isShowPasswordRegister"
          id="applicant-password-register"
          v-model.trim="register.password"
          :placeholder="translations[10948]"
          :title-widget="translations[2521]"
        />
        <PasswordPattern
          v-if="isShowPasswordRegister"
          id="applicant-password-register2"
          v-model.trim="register.password_repeat"
          :placeholder="translations[236]"
          :title-widget="translations[2521]"
        />
        <b-form-group v-if="isApplicantField(typeField.visible, regField.birthdate)" class="position-relative mb-0">
          <b-input-group>
            <b-form-datepicker
              v-model="birthdateValue"
              button-only
              right
              :locale="lang"
              :max="maxDate"
              :label-no-date-selected="translations[1724]"
              :label-next-month="translations[3407]"
              :label-prev-month="translations[3406]"
              :label-next-year="translations[10815]"
              :label-prev-year="translations[10814]"
              :label-current-month="translations[10813]"
              :label-help="translations[10812]"
              :label-prev-decade="translations[15220]"
              :label-next-decade="translations[15221]"
              show-decade-nav
              :required="isApplicantField(typeField.mandatory, regField.birthdate)"
              @context="onBirthdateContext"
            />
            <b-form-input
              v-model="birthdateValue"
              v-mask="'####-##-##'"
              type="text"
              :placeholder="`${translations[1724]} ${translations[15222]}`"
              autocomplete="off"
            />
          </b-input-group>
          <!-- using for required control -->
          <b-form-input
            v-if="isApplicantField(typeField.mandatory, regField.birthdate)"
            v-model="register.birthdate"
            required
            tabindex="-1"
            class="position-absolute top-0 -z-1"
          />
        </b-form-group>
        <b-form-group v-if="isApplicantField(typeField.visible, regField.salutation)" class="mb-0">
          <b-form-select
            v-model="register.salutation"
            :options="getApplicantField(regField.salutation).options"
            text-field="name"
            :placeholder="translations[10823]"
            :required="isApplicantField(typeField.mandatory, regField.salutation)"
          />
        </b-form-group>
        <b-form-group v-if="isApplicantField(typeField.visible, regField.country)" class="mb-0">
          <v-select
            label="name"
            v-model="registerCountry"
            :options="getApplicantField(regField.country).options"
            :placeholder="translations[15035]"
            :dir="isRtl"
            class="form-control default"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="isApplicantField(typeField.mandatory, regField.country) && !registerCountry"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </b-form-group>
        <b-form-group v-if="isApplicantField(typeField.visible, regField.citizenship)" class="mb-0">
          <v-select
            label="name"
            v-model="registerCitizenship"
            :options="getApplicantField(regField.citizenship).options"
            :placeholder="translations[15036]"
            :dir="isRtl"
            class="form-control default"
            multiple
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="isApplicantField(typeField.mandatory, regField.citizenship) && (registerCitizenship.length === 0)"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </b-form-group>
      </div>
      <b-form-group v-if="isApplicantField(typeField.visible, regField.wishes)" v-slot="{ ariaDescribedby }" class="fs-6 mb-1 mt-3">
        <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[15195] }}</h3>
        <b-form-checkbox-group
          v-model="register.wishes"
          :options="getApplicantField(regField.wishes).options"
          :aria-describedby="ariaDescribedby"
          :required="isApplicantField(typeField.mandatory, regField.wishes) ? register.wishes.length === 0 : false"
          plain
          stacked
          text-field="name"
        />
      </b-form-group>
      <b-form-group v-if="isApplicantField(typeField.visible, regField.education_employment)" v-slot="{ ariaDescribedby }" class="fs-6 mb-1 mt-3">
        <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[15202] }}</h3>
        <b-form-checkbox-group
          v-model="register.education_employment"
          :options="getApplicantField(regField.education_employment).options"
          :aria-describedby="ariaDescribedby"
          :required="isApplicantField(typeField.mandatory, regField.education_employment) ? register.education_employment.length === 0 : false"
          plain
          stacked
          text-field="name"
        />
      </b-form-group>
      <b-form-group v-if="isApplicantField(typeField.visible, regField.status)" v-slot="{ ariaDescribedby }" class="fs-6 mb-1 mt-3">
        <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[15208] }}</h3>
        <b-form-radio
          plain
          v-for="radioItem in getApplicantField(regField.status).options"
          :key="radioItem.value"
          v-model="register.status"
          :aria-describedby="ariaDescribedby"
          name="radios-status"
          :value="radioItem.value"
          :required="isApplicantField(typeField.mandatory, regField.status)"
        >
          <span v-b-tooltip.hover :title="radioItem.tooltip"> {{ radioItem.name }}</span></b-form-radio
        >
      </b-form-group>
      <div v-if="isGroupVisible(GROUP_SELECTED_CONTACT)" class="mb-1 mt-3">
        <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[15219] }}</h3>
        <b-form-group v-if="isApplicantField(typeField.visible, regField.consultant_id)" v-slot="{ ariaDescribedby }">
          <h6 class="fw-normal mb-1">{{ translations[15200] }}</h6>
          <b-form-select
            v-model="register.consultant_id"
            :options="getApplicantField(regField.consultant_id).options"
            text-field="name"
            :aria-describedby="ariaDescribedby"
            :placeholder="translations[1505]"
            :required="isApplicantField(typeField.mandatory, regField.consultant_id)"
          />
        </b-form-group>
        <b-form-group v-if="isApplicantField(typeField.visible, regField.referral_crm_company_id)" v-slot="{ ariaDescribedby }">
          <h6 class="fw-normal mb-1">{{ translations[15201] }}</h6>
          <b-form-select
            v-model="register.referral_crm_company_id"
            :options="sortedReferralOptions"
            text-field="name"
            :aria-describedby="ariaDescribedby"
            :placeholder="translations[1505]"
            :required="isApplicantField(typeField.mandatory, regField.referral_crm_company_id)"
          />
        </b-form-group>
      </div>
    </div>
    <!--    new field 30.07.2024-->
    <div>
      <h3 class="ts-register-section-title fw-semibold mt-3 mb-2">{{ translations[15218] }}</h3>
      <b-form-group v-if="isApplicantField(typeField.visible, regField.consent_registration_fee)" class="mb-1">
        <b-form-checkbox
          :class="[{ 'is-invalid': isConsentError }]"
          aria-describedby="consent-live-feedback"
          v-model="register.consent_registration_fee"
          name="check-button"
          plain
        >
          <p class="ts-register-consent small mb-0" v-html="translations[15044]"></p>
          <p class="ts-register-consent small mb-0">
            <span v-html="getApplicantField(regField.consent_registration_fee).value" />
          </p>
        </b-form-checkbox>
        <b-form-invalid-feedback id="consent-live-feedback">
          {{ translations[15057] }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="mb-2">
        <b-form-checkbox
          :class="[{ 'is-invalid': isPrivacyError }]"
          v-model="isRegisterPrivacy"
          name="check-button"
          aria-describedby="privacy-live-feedback"
          plain
        >
          <p class="ts-register-consent small mb-0" ref="content" v-html="translations[15008]"></p>
        </b-form-checkbox>
        <b-form-invalid-feedback id="privacy-live-feedback">
          {{ translations[15058] }}
        </b-form-invalid-feedback>
      </b-form-group>
    </div>

    <b-form-group v-if="isApplicantField(typeField.visible, regField.captcha) && !isRecaptchaReload" class="mb-1 mt-2">
      <Captcha v-model="captcha" @change="updateCaptchaToken" />
    </b-form-group>
    <b-alert :show="isRecaptchaError" variant="danger">
      <span>{{ translations[9209] }}</span>
    </b-alert>
  </b-form>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import RegistrationFieldsMixin from '@/mixins/RegistrationFieldsMixin';
import { RegistrationField, TypeField } from '@/types/Login';
import Captcha from '@/components/Widget/Captcha.vue';
import { getCaptchaVerify } from '@/api/Captcha';
import PasswordPattern from '@/components/Widget/PasswordPattern.vue';

const GROUP_SELECTED_CONTACT = 5;

@Component({
  components: {
    PasswordPattern, Captcha,
  },
})
export default class RegisterApplicantForm extends mixins(RegistrationFieldsMixin) {
  GROUP_SELECTED_CONTACT = GROUP_SELECTED_CONTACT;

  get translations() {
    return AppModule.translation;
  }

  get sid() {
    return AppModule.sid;
  }

  get lang() {
    return AppModule.language;
  }

  get isRtl() {
    return AppModule.rtl;
  }

  get isErrorsRegister() {
    return this.isUsernameExist || this.isEmailExist;
  }

  get getPasswordRegister() {
    return AppModule.setting?.registration_with_password;
  }

  isGroupVisible(groupId: number) {
    return this.applicantRegistrationFields.filter((el: any) => el.group_id === groupId).some((el: any) => el[this.typeField.visible]);
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.$emit('submit');
    }
  }

  isSuccessRegister = false;

  register = {
    username: '',
    password: '',
    password_repeat: '',
    email: '',
    sid: this.sid,
    lang: this.lang,
    firstname: '',
    lastname: '',
    // new field
    birthdate: '',
    country: '',
    citizenship: '',
    consent_registration_fee: false,
    status: null,
    salutation: null,
    consultant_id: null,
    referral_crm_company_id: null,
    wishes: [],
    education_employment: [],
  } as any;

  isRegisterPrivacy = false;

  isRegisterPasswordError = false;

  isPrivacyError = false;

  isConsentError = false;

  get isErrorsRegisterValidate() {
    return this.isPrivacyError || this.isConsentError || this.isRegisterPasswordError;
  }

  birthdateValue = '';

  onBirthdateContext(ctx: any) {
    if (+this.maxDate < +new Date(ctx.selectedYMD)) return;
    this.register.birthdate = ctx.selectedYMD;
  }

  get maxDate() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return new Date(today);
  }

  @Watch('isRegisterPrivacy')
  handler(val: boolean) {
    if (val) this.isPrivacyError = false;
  }

  @Watch('register.consent_registration_fee')
  handlerConsent(val: boolean) {
    if (val) this.isConsentError = false;
  }

  @Watch('register.password')
  handlerPassword(val: boolean) {
    if (val) this.isRegisterPasswordError = false;
  }

  @Watch('register.password_repeat')
  handlerPasswordRepeat(val: boolean) {
    if (val) this.isRegisterPasswordError = false;
  }

  isEmailExist = false;

  isUsernameExist = false;

  registerCountry: { value?: string, name?: string } | string = '';

  registerCitizenship: { value?: string, name?: string }[] = [];

  get isShowPasswordRegister() {
    return AppModule.setting?.registration_with_password;
  }

  reloadTab() {
    this.$bvModal.hide('register-modal');
    this.$bvModal.show('login-modal');
  }

  resetErrors() {
    this.isEmailExist = false;
    this.isUsernameExist = false;
  }

  async onLogin() {
    try {
      const login = {
        username: this.register.username,
        password: this.register.password,
        sid: this.sid,
      };
      await UserModule.LoginApplicant(login);
      await this.$router.push({
        name: 'Cabinet',
        query: {
          lang: this.lang,
          ...(UserModule.openAgentPageOnCabinet && { agent: '1' }),
        },
      });
    } catch (error: any) {
      console.error(error);
    }
  }

  get getOptionalInvisibleFields() {
    return this.applicantRegistrationFields.filter((el) => Object.prototype.hasOwnProperty.call(el, TypeField.visible) && !el.visible).map((el) => el.name);
  }

  async onRegistration() {
    const form = this.$refs.registerForm as HTMLFormElement;
    if (!form.reportValidity()) {
      return;
    }

    this.resetErrors();

    if (!this.isRegisterPrivacy) {
      this.isPrivacyError = true;
    }

    if (this.isApplicantField(TypeField.visible, RegistrationField.consent_registration_fee) && !this.register.consent_registration_fee) {
      this.isConsentError = true;
    }

    if (!this.isShowPasswordRegister) {
      delete this.register.password;
      delete this.register.password_repeat;
    } else if (this.register.password !== this.register.password_repeat) {
      this.isRegisterPasswordError = true;
    }

    if (this.isErrorsRegisterValidate) {
      return;
    }

    if (this.isApplicantField(TypeField.visible, RegistrationField.captcha)) {
      await this.captchaVerify();
      if (this.isRecaptchaError) {
        return;
      }
    }

    try {
      if (this.isApplicantField(TypeField.visible, RegistrationField.country)) {
        this.register.country = (this.registerCountry as { value?: string }).value || '';
      }

      if (this.isApplicantField(TypeField.visible, RegistrationField.citizenship)) {
        this.register.citizenship = (this.registerCitizenship as { value?: string, name?: string }[]).map((x) => x.value) || [];
      }

      this.getOptionalInvisibleFields.forEach((field) => {
        delete this.register[field];
      });

      await UserModule.RegisterApplicant(this.register).then((response: any) => {
        if (response.autolog) {
          this.onLogin();
        } else {
          this.isSuccessRegister = true;
          this.$emit('registered');
        }
      });
    } catch (error: any) {
      if (error.response.data.message === 'email already exists') this.isUsernameExist = true;
      if (error.response.data.message === 'username already exists') this.isUsernameExist = true;
      if (error.response.data.message === 'invalid params') this.isUsernameExist = true;
      this.$bvToast.toast(error.response.data.message, {
        title: 'Warning',
        variant: 'warning',
        autoHideDelay: 5000,
        solid: true,
      });
    }
  }

  @Watch('translations', { deep: true })
  handlerTranslation(newVal: any[]) {
    if (newVal && newVal[15008]) {
      this.$nextTick(() => {
        this.initializeModal();
      });
    }
  }

  initializeModal() {
    const termsLink = (this.$refs as any).content.querySelector('.terms-link');
    if (termsLink) {
      termsLink.addEventListener('click', (event: any) => {
        event.preventDefault();
        this.$bvModal.show('terms-modal');
      });
    }
  }

  async mounted() {
    this.initializeModal();
  }
}
</script>
